module.exports = __webpack_public_path__ + "img/yl3039.f65dd32f.png";